<template>
    <div class="dvgraficoline">
        <v-chart  :options="options"/>
    </div>
</template>
<style>
 
</style>
<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'

import 'echarts/theme/dark'
import util from '../utilitarios/util.js'

export default {
    name : "cmpgraficoline",
    components: {
        'v-chart': ECharts
    },
    props:[		
        'titulo',
        'agrupamento',
			'series'
        
    ],
    computed:{
        temaSistema(){
            return this.$store.state.temasistema;
        },
        options(){
            return {
                color: util.gerarpaletagrafico(this.temaSistema, 11),
                title: {
                    text: this.titulo || ''
                },
                tooltip: {
                    trigger: 'axis'
                },
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                toolbox: {
                    feature: {
                        saveAsImage: {
                            show  : false,
                            title : 'Salvar gráfico'
                        }
                    }
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: this.agrupamento || []
                },
                yAxis: {
                    type: 'value'
                },
                series: this.series || []
            };
        }
    }    
}
</script>
<style scoped>
  
</style>
